export default __webpack_public_path__ + "static/media/w_mas_2025_h.e882efa6.jpg";